import Link from 'next/link'

import { Box, Button } from '@material-ui/core'

import CollapseItems from '~/components/shared/CollapseItems'
import { Title } from '~/components/shared/Text'

import useAhoy from '~/hooks/useAhoy'
import Paths from '~/utils/paths'

export const DealerDetails = ({ data, items }) => {
  const ahoy = useAhoy()

  const handleClick = (open) => {
    if (open) {
      window.dataLayer?.push({
        event: 'ShowContactDetails'
      })
      ahoy.track('view_contact', {
        seller_id: data.id
      })
    }
  }

  return (
    <>
      <Title variant="h2" fontSize={20} fontWeight={500} mt={0} mb={1}>
        Contact Details
      </Title>
      <Box mb={2}>
        <CollapseItems
          enteredClass="view-contact-button"
          count={0}
          items={items}
          onClick={handleClick}
        >
          {(show) => (show ? 'Hide contact details' : 'Show contact details')}
        </CollapseItems>
      </Box>
      <Link
        href={Paths.search.buildSearch({
          by_dealer: data.name
        })}
        passHref
      >
        <Button color="secondary" variant="contained">
          Find Dealer Stock
        </Button>
      </Link>
    </>
  )
}
